import { useMutation } from '@apollo/react-hooks'
import { useContext } from 'react'
import ChannelContext from '@jetshop/core/components/ChannelContext'
import RegisterCustomerMutation from './RegisterCustomerMutation.gql'
import { buildRegisterCustomerInput } from './buildRegisterCustomerInput'

/**
 * Calls `signUp` with variables built from flat registration fields.
 * On success, `data.signUp.token.value` is the JWT.
 * Uses {@link ChannelContext} for the active channel (signup input culture/country).
 *
 * @param {import('@apollo/react-hooks').MutationHookOptions} [options]
 */
export function useRegisterCustomer(options = {}) {
   const { selectedChannel } = useContext(ChannelContext) || {}
   const [mutate, result] = useMutation(RegisterCustomerMutation, options)

   /**
    * @param {Parameters<typeof buildRegisterCustomerInput>[0]} fields
    */
   function registerCustomer(fields) {
      // Jetshop Apollo already sets channelId; adding it here duplicates the header ("3, 3").
      return mutate({
         variables: {
            input: buildRegisterCustomerInput({ ...fields, channel: selectedChannel }),
         },
      })
   }

   return [registerCustomer, result]
}
